import { createSelector } from 'reselect';
import get from 'lodash/get';

export const userCountryCodeSelector = (state) => get(state, 'application.setup.userCountryCode');

export const userCountryAreaSelector = createSelector(
  userCountryCodeSelector,
  (userCountryCode) => {
    if (!userCountryCode) {
      return null;
    }
    switch (userCountryCode) {
      // case 'be':
      // case 'lu':
      // case 'li':
      case 'de':
      case 'ch':
      case 'at':
        return 'GSA';
      case 'gb':
      case 'uk':
        return 'UK';
      default:
        return 'OTHER';
    }
  },
);
